import { gql } from '@apollo/client';
import RESOURCE_TYPE_FRAGMENT from '../fragments/resource-type';
import RESOURCE_TYPE_ASSETS_FRAGMENT from '../fragments/resource-type-assets';

const GET_RESOURCE_TYPES = gql`
  query getResourceTypes($where: ResourceTypesWhereInput) {
    resourceTypes(where: $where) {
      ...BaseResourceType
      ...BaseResourceTypeAssets
    }
  }
  ${RESOURCE_TYPE_FRAGMENT}
  ${RESOURCE_TYPE_ASSETS_FRAGMENT}
`;

export default GET_RESOURCE_TYPES;
